<template>
  <v-container fluid grid-list-sm>
    <v-layout row wrap>
      <v-flex xs12>
        <v-card color="semBl" width="100%">
          <v-card-text>
            <v-autocomplete
              v-model="school"
              :items="schools"
              label="Institución Educativa Oficial"
              item-text="properties.name"
              return-object
              color="semAz"
              class="title font-weight-medium"
              prepend-icon="mdi-school"
            >
              <template v-slot:append-outer>
                <v-slide-x-reverse-transition
                  mode="out-in"
                >
                  <v-btn color="semAz" dark @click="dialog = true" v-if="school.id !== 'IEO'">
                    Mostrar Información
                  </v-btn>
                </v-slide-x-reverse-transition>
              </template>
            </v-autocomplete>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card height="70vh" width="100%">
          <!-- <v-card-text> -->
            <!-- <v-responsive :aspect-ratio="16/6"> -->
              <Map/>
            <!-- </v-responsive> -->
          <!-- </v-card-text> -->
        </v-card>
      </v-flex>
    </v-layout>

    <v-dialog
      v-model="dialog"
      full-width
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar dark color="semVr">
          <v-btn icon color="semRj" @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ school.properties.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn dark flat @click="dialog = false">Volver al Mapa</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container grid-list-md>
          <v-layout row wrap>
            <v-flex xs12 sm4>
              <v-card flat>
                <span class="subheading">
                  <strong>Dirección:</strong> {{ school.properties.dir }}
                </span> <br>
                <span class="subheading">
                  <strong>Teléfono:</strong> {{ school.properties.tel }}
                </span> <br>
                <span class="subheading">
                  <strong>E-mail:</strong> {{ school.properties.email }}
                </span>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card flat>
                <span class="subheading">
                  <strong>Estudiantes:</strong> {{ school.properties.students }}
                </span> <br>
                <span class="subheading">
                  <strong>Profesores:</strong> {{ school.properties.teachers }}
                </span> <br>
                <!-- <span class="subheading">
                  <strong>Estudiantes por Profesores:</strong>
                  {{ Math.trunc(school.properties.students / school.properties.teachers) }}
                </span> <br> -->
                <span class="subheading">
                  <strong>Puntaje Saber-11:</strong> {{ school.properties.saber }}
                </span> <br>
                <span class="subheading">
                  <strong>Índice Sintético de Calidad en Primaria:</strong> {{ school.properties.primary }}
                </span> <br>
                <span class="subheading">
                  <strong>Índice Sintético de Calidad en Media:</strong> {{ school.properties.med }}
                </span> <br>
                <span class="subheading">
                  <strong>Índice Sintético de Calidad en Secundaria:</strong> {{ school.properties.second }}
                </span>
              </v-card>
            </v-flex>

            <v-flex xs12 sm4>
              <v-card flat>
                <v-card-text class="text-xs-center">
                  <span class="subheading">
                    <strong>Nivel general de IEO:</strong>
                  </span> <br>
                  <v-icon
                    x-large
                    :color="school.properties.level"
                  >
                    mdi-thermometer
                  </v-icon> <br>
                  {{ school.properties.level }}
                </v-card-text>

                <v-card-text class="text-xs-center">
                  <v-btn
                    color="semRj"
                    class="white--text"
                    :href="'https://' + school.properties.link"
                    target="_blank"
                  >
                    Visitar sitio 2018
                  </v-btn>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <v-card-text>
                (*) Datos suministrados por la Secretaría de Educación Municipal de Santiago de Cali
              </v-card-text>
            </v-flex>
          </v-layout>
        </v-container>

        <v-tabs
          v-model="tabs"
          centered
          color="semBl"
          slider-color="semRj"
          active-class="semRj--text"
          icons-and-text
          show-arrows
          :key="tabsKey"
        >
          <v-tab href="#tab-dataSheet">
            Ficha técnica
            <v-icon right>mdi-cards-outline</v-icon>
          </v-tab>

          <v-tab href="#tab-indicators">
            Indicadores
            <v-icon right>mdi-sign-caution</v-icon>
          </v-tab>

          <v-tab href="#tab-recommendations">
            Reflexiones / Recomendaciones
            <v-icon right>mdi-check-all</v-icon>
          </v-tab>

          <!-- Vistas -->
          <v-tab-item
            value="tab-dataSheet"
          >
            <!-- <v-layout row wrap v-if="school.id !== 'IEO'">
              <v-flex xs12 ma-3>
                <v-expansion-panel inset>
                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="title">Actores que Participaron en la Evaluación</div>
                    </template>

                    <v-card>
                      <v-container grid-list-md>
                        <v-layout row wrap>
                          <v-flex xs12 sm7>
                            <v-card>
                              <v-card-text class="px-0">
                                <apexchart
                                  type=donut
                                  height=350
                                  :options="chartOptions"
                                  :series="chartSeries"
                                  :chartKey="chartKey"
                                />
                              </v-card-text>
                            </v-card>
                          </v-flex>

                          <v-flex d-flex xs12 sm5>
                            <v-card width="100%">
                              <v-card-title class="title">
                                Actores Participantes Externos
                              </v-card-title>

                              <v-card-text
                                v-for="(act, index) in school.properties.stats.actors_b"
                                :key="index"
                              >
                                {{ act }}
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-expansion-panel-content>

                  <v-expansion-panel-content>
                    <template v-slot:header>
                      <div class="title">Proyectos Implementados</div>
                    </template>

                    <v-card>
                      <v-list two-line>
                        <template v-for="(prj, index) in projects">
                          <v-list-tile
                            :key="prj.value"
                            @click="loadPrj(prj.value)"
                          >
                            <v-list-tile-content>
                              <v-list-tile-title>
                                {{ prj.text }}
                              </v-list-tile-title>

                              <v-list-tile-sub-title>
                                {{ prjLevel(prj.value) }}
                              </v-list-tile-sub-title>
                            </v-list-tile-content>
                          </v-list-tile>

                          <v-divider
                            v-if="index + 1 < projects.length"
                            :key="index"
                          ></v-divider>
                        </template>
                      </v-list>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-flex>
            </v-layout> -->

            <v-card v-if="school.id !== 'IEO'">
              <v-card-text>
                <v-card>
                  <v-toolbar color="semAz" dark>
                    <v-toolbar-title>Actores que Participaron en la Evaluación</v-toolbar-title>
                  </v-toolbar>

                  <v-container grid-list-md>
                    <v-layout row wrap>
                      <v-flex xs12 sm7>
                        <v-card>
                          <v-card-text class="px-0">
                            <apexchart
                              type=donut
                              height=350
                              :options="chartOptions"
                              :series="chartSeries"
                              :chartKey="chartKey"
                            />
                          </v-card-text>
                        </v-card>
                      </v-flex>

                      <v-flex d-flex xs12 sm5>
                        <v-card width="100%">
                          <v-card-title class="title">
                            Actores Participantes Externos
                          </v-card-title>

                          <v-card-text
                            v-for="(act, index) in school.properties.stats.actors_b"
                            :key="index"
                          >
                            {{ act }}
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card>
              </v-card-text>

              <v-card-text>
                <v-card>
                  <v-toolbar color="semAz" dark>
                    <v-toolbar-title>Proyectos Implementados</v-toolbar-title>
                  </v-toolbar>

                  <v-list two-line>
                    <template v-for="(prj, index) in projects">
                      <v-list-tile
                        :key="prj.value"
                        avatar
                        @click="loadPrj(prj.value)"
                      >
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{ prj.text }}
                          </v-list-tile-title>
                        </v-list-tile-content>

                        <v-list-tile-action>
                          <v-icon
                            x-large
                            :color="prjLevel(prj.value)"
                          >
                            mdi-thermometer
                          </v-icon>
                          <v-list-tile-action-text>{{ prjLevel(prj.value) }}</v-list-tile-action-text>
                        </v-list-tile-action>
                      </v-list-tile>

                      <v-divider
                        v-if="index + 1 < projects.length"
                        :key="index"
                      ></v-divider>
                    </template>
                  </v-list>
                </v-card>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item
            value="tab-indicators"
          >
            <v-card>
              <v-card-text>
                <v-autocomplete
                  v-model="project"
                  hint="Seleccione el proyecto, para ver los detalles"
                  :items="projects"
                  label="Proyectos Implementados en la IEO"
                  persistent-hint
                  prepend-icon="mdi-book-open-page-variant"
                  no-data-text="No se tienen proyectos asociados"
                  color="semRj"
                  :key="projectKey"
                />
              </v-card-text>

              <v-divider/>

              <v-card-text v-if="project" :key="chartKeySynthetic">
                <v-card tile>
                  <v-toolbar color="semAz" dark>
                    <v-toolbar-title>Indicadores Sintéticos</v-toolbar-title>
                  </v-toolbar>

                  <v-window v-model="onboarding">
                    <v-window-item
                      v-for="(indSynt, index) in school.properties.projects[project].synthetic"
                      :key="index"
                    >
                      <v-card flat>
                        <v-layout row wrap>
                          <v-flex xs12 sm6>
                            <v-card flat>
                              <radial-chart
                                :indSynt="indSynt"
                              />
                            </v-card>
                          </v-flex>

                          <v-flex xs12 sm6>
                            <v-card flat>
                              <v-card-title semBl-title class="title">
                                Descripción
                              </v-card-title>
                              <v-card-text>
                                {{ indSynt.des }}
                              </v-card-text>
                            </v-card>
                          </v-flex>
                        </v-layout>
                      </v-card>
                    </v-window-item>
                  </v-window>

                  <v-card-actions v-if="school.properties.projects[project].synthetic.length > 1"
                    class="justify-space-between"
                  >
                    <v-btn
                      flat
                      @click="prev"
                    >
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-item-group
                      v-model="onboarding"
                      class="text-xs-center"
                      mandatory
                    >
                      <v-item
                        v-for="n in school.properties.projects[project].synthetic.length"
                        :key="`btn-${n}`"
                      >
                        <v-btn
                          slot-scope="{ active, toggle }"
                          :input-value="active"
                          icon
                          @click="toggle"
                        >
                          <v-icon>mdi-record</v-icon>
                        </v-btn>
                      </v-item>
                    </v-item-group>
                    <v-btn
                      flat
                      @click="next"
                    >
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-card-actions>

                  <v-card-text>
                    (*) Un indicador Sintético compila en una sola medida dos o más indicadores individuales.
                  </v-card-text>
                </v-card>
              </v-card-text>

              <v-divider/>

              <v-card-text v-if="project">
                <v-card>
                  <v-toolbar color="semAz" dark>
                    <v-toolbar-title>Indicadores Generales</v-toolbar-title>
                  </v-toolbar>

                  <v-data-table
                    :headers="headers"
                    :items="indicators"
                    :expand="expand"
                    class="elevation-1"
                    :key="tableKey"
                    item-key="ind"
                  >
                    <template v-slot:items="props">
                      <td>{{ props.item.ind }}</td>

                      <template v-if="props.item.id">
                        <td class="text-xs-center">
                          <v-icon
                            x-large
                            :color="props.item.color ? props.item.color : 'sem6'"
                          >mdi-thermometer</v-icon> <br>
                          {{ props.item.res }} <br>
                          {{ props.item.color }}
                        </td>
                        <td>
                          <strong>Actor:</strong> {{ props.item.actor }} <br>
                          <strong>Técnica de Recolección:</strong> {{ props.item.tipo }} <br>
                          <strong>Unidad de medida:</strong> {{ props.item.unidad }} <br>
                          <!-- <strong v-if="props.item.calculo" >Modo de Cálculo:</strong> {{ props.item.calculo }} -->
                        </td>
                      </template>

                      <template v-else>
                        <td class="text-xs-center">
                          <v-icon
                            x-large
                            :color="props.item.color ? props.item.color : 'sem6'"
                          >mdi-thermometer</v-icon> <br>
                          {{ props.item.color }}
                        </td>
                        <td v-html="props.item.res"></td>
                      </template>
                    </template>

                    <template v-slot:pageText="props">
                      {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
                    </template>
                  </v-data-table>
                </v-card>
              </v-card-text>
            </v-card>
          </v-tab-item>

          <v-tab-item
            value="tab-recommendations"
          >
            <v-card>
              <v-card-text>
                <v-autocomplete
                  v-model="project"
                  hint="Seleccione el proyecto, para ver los detalles"
                  :items="projects"
                  label="Proyectos Implementados en la IEO"
                  persistent-hint
                  prepend-icon="mdi-book-open-page-variant"
                  no-data-text="No se tienen proyectos asociados"
                  color="semRj"
                  :key="projectKey"
                />
              </v-card-text>

              <v-divider/>
              <v-card-text v-if="project">
                <v-card-text v-if="school.properties.projects[project].reflections">
                  <v-card>
                    <v-card-title class="title">
                      Reflexiones
                    </v-card-title>
                    <v-card-text>
                      {{ school.properties.projects[project].reflections }}
                    </v-card-text>
                  </v-card>
                </v-card-text>

                <v-card-text v-if="school.properties.projects[project].recommendations">
                  <v-card>
                    <v-card-title class="title">
                      Recomedaciones
                    </v-card-title>
                    <v-card-text>
                      {{ school.properties.projects[project].recommendations }}
                    </v-card-text>
                  </v-card>
                </v-card-text>
              </v-card-text>

              <!-- <v-card-text>
                {{ school.properties.recommendations }}
              </v-card-text> -->
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import Map from './Map'
  import RadialChart from './RadialChart'
  import VueApexCharts from 'vue-apexcharts'

  import schoolsData from './../data/schools'

  export default {
    name: 'Schools',

    components: {
      apexchart: VueApexCharts,
      'radial-chart': RadialChart,
      Map

    },

    created () {
      /*eslint no-console: ["error", { allow: ["log", "error"] }] */
      // schoolsData.forEach(element => console.log(element.id, '\t', element.geometry.coordinates[0], '\t', element.geometry.coordinates[1], '\t', element.properties.dir, '\t', element.properties.tel, '\t', element.properties.email))
    },

    data: function() {
      return {
        background: require('../assets/background.png'),

        lorem: `Lorem ipsum dolor sit amet, mel at clita quando. Te sit oratio vituperatoribus, nam ad ipsum posidonium mediocritatem, explicari dissentiunt cu mea. Repudiare disputationi vim in, mollis iriure nec cu, alienum argumentum ius ad. Pri eu justo aeque torquatos.`,
        dialog: false,

        schools: schoolsData,
        sch: null,
        school: {
          id: 'IEO',
          properties: {
            projects: [],
            recommendations: {
            },
            stats: {
            }
          }
        },
        project: null,
        projectsDef: [
          { value: 'prj01', text: 'P01 Conformación de Semilleros TIC.' },
          { value: 'prj02', text: 'P02 Fortalecimiento de las competencias básicas de los estudiantes.' },
          { value: 'prj021', text: 'P02.1 Semilleros de cultura ciudadana.' },
          { value: 'prj03', text: 'P03 Implementación de sistemas de gestión de calidad escolar.' },
          { value: 'prj031', text: 'P03.1 Gestión calidad: Mediadores de comunicación' },
          { value: 'prj04', text: 'P04 Mejoramiento de la gestión curricular.' },
          { value: 'prj05', text: 'P05 Fortalecimiento de las instituciones educativas rurales con proyectos pedagógicos productivos pertinentes.' },
          { value: 'prj06', text: 'P06 Recreación en actividades lúdicas para niños y niñas de la primera infancia.' },
          { value: 'prj07', text: 'P07 Adecuación de espacios de ludoteca.' },
          { value: 'prj08', text: 'P08 Recreación a través de la Iniciación y Formación Deportiva.' },
          { value: 'prj09', text: 'P09 Fortalecimiento de las competencias básicas desde la oferta formativa en arte y cultura.' },
          { value: 'prj10', text: 'P10 Capacitación en iniciación y sensibilización artística en comunas y corregimientos.' }
        ],

        tabs: null,

        headers: [
          { text: 'Indicador', align: 'center', sortable: false, value: 'ind' },
          // { text: 'Resultado', align: 'center', sortable: false, value: 'res' },
          { text: 'Nivel', align: 'center', sortable: false, value: 'niv' },
          // { text: 'Unidad de Medida', align: 'center', sortable: false, value: 'med' },
          // { text: 'Actor', align: 'center', sortable: false, value: 'act' },
          { text: 'Justificación del Nivel', align: 'center', sortable: false, value: 'res' }
        ],
        expand: false,
        indicators :null,
        projectKey: 0,
        tableKey: 0,
        tabsKey: 0,

        chartOptions: {
          plotOptions: {
            pie: {
              customScale: 1,
              donut: {
                size: '65%',
                background: 'transparent',
                labels: {
                  show: true,
                  name: {
                    show: true,
                  },
                  value: {
                    show: true,
                    formatter: function (val, w) {
                      let total = w.globals.seriesTotals.reduce(function(a, b){ return a + b })
                      let perc = (val*100) / total
                      return Number.parseFloat(perc).toFixed(1) + ' %'
                    }
                  },
                  total: {
                    show: true,
                    label: 'Total',
                    formatter: function (w) {
                      return w.globals.seriesTotals.reduce(function(a, b){ return a + b })
                    }
                  }
                }
              },
            }
          },
          colors: ['#4177A6', '#41A66C', '#D94E5A', '#F2C53D',
                   '#df040b', '#59A8D9', '#b3b2b2', '#f9b233'],
          labels: ['Actor 1', 'Actor 2', 'Actor 3', 'Actor 4'],
          legend: {
            show: true,
            floating: true,
            fontSize: '12px',
            position: 'left',
            labels: {
              useSeriesColors: true
            },
            markers: {
              size: 0
            },
            formatter: function(seriesName, opts) {
              return seriesName + ": " + opts.w.globals.series[opts.seriesIndex]
            },
            itemMargin: {
              horizontal: 1
            }
          },
          responsive: [{
            breakpoint: 721,
            options: {
              legend: {
                show: false
              }
            }
          }]
        },
        chartSeries: [150,0,50,0],
        chartKey: 0,
        chartKeySynthetic: 0,
        onboarding: 0
      }
    },

    watch: {
      '$store.state.school': function () {
        this.school = this.$store.state.school
        this.project = null
        this.projectKey += 1
        this.indicators = null
        this.tableKey += 1
        this.tabs = 'tab-dataSheet'
        this.tabsKey += 1
      },
      school: function () {
        this.$store.commit('selected_school', this.school)

        this.chartOptions.labels = Object.keys(this.school.properties.stats.actors)
        this.chartSeries = Object.values(this.school.properties.stats.actors)

        this.chartKey += 1
      },
      project: function () {
        if (this.project !== null){
          this.indicators = this.school.properties.projects[this.project].indicators
        }
        this.tableKey += 1
        this.chartKeySynthetic += 1
        this.onboarding = 0
      }
    },

    computed: {
      projects: function () {
        let prjSch = Object.keys(this.school.properties.projects)
        let prjts = this.projectsDef
        prjts = prjts.filter(
          prj => prjSch.includes(prj.value)
        )
        return prjts
      }
    },

    methods: {
      align (val) {
        let algn = 'left'
        if (Number(val) || val === '0') {
          algn = 'center'
        }
        return algn
      },
      loadPrj (prj) {
        this.project = prj
        this.tabs = 'tab-indicators'
      },
      prjLevel (prj) {
        return this.school.properties.projects[prj].level
      },

      next () {
        this.onboarding = this.onboarding + 1 === this.length
          ? 0
          : this.onboarding + 1
      },
      prev () {
        this.onboarding = this.onboarding - 1 < 0
          ? this.length - 1
          : this.onboarding - 1
      }
    }
  }
</script>
